import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({
  fontWeights, fontSizes, lineHeights, breakpoints, palette,
}: Theme) => ({
  title: {
    margin: 0,
    marginTop: '1rem',
    fontSize: fontSizes.lg,
    lineHeight: 1.4,
    fontWeight: fontWeights.medium,
    textAlign: 'center',
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.xxl,
    },
  },

  text: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    textAlign: 'center',
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      maxWidth: '20.1rem',
    },
  },

  c2cText: {
    [breakpoints.up('sm')]: {
      maxWidth: '100%',
    },
  },

  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '1.5rem',
    marginBottom: '1.5rem',
    paddingBottom: '1rem',
    borderBottom: `0.0625rem solid ${palette.grey['200']}`,
    [breakpoints.up('sm')]: {
      gap: '0.2rem',
    },
  },

  statusTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  statusTextContainerRow: {
    flexDirection: 'row',
  },

  statusImgContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    minHeight: '2.7rem',
  },

  statusImg: {
    width: '11.875rem',
  },

  statusImgSmall: {
    width: '2.25rem',
    height: '2.25rem',
  },

  popoverContent: {
    position: 'relative',
    width: '15.5rem',
    height: '10.5rem',
    padding: '1rem 2.87rem 1rem 0.5rem',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },

  popoverText: {
    fontSize: '0.75rem',
    lineHeight: '1.3',
    margin: 0,
  },

  popoverTextFirst: {
    marginBottom: '0.5rem',
  },

  icoButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    margin: 0,
    padding: 0,
    cursor: 'pointer',
  },

  closeButton: {
    position: 'absolute',
    width: '0.625rem',
    top: '1rem',
    right: '2rem',
  },

  infoButton: {
    marginLeft: '0.25rem',
  },

  linkUnderline: {
    color: palette.primary.dark,
    fontSize: '0.75rem',
  },

  popoverContentDelayed: {
    position: 'relative',
    width: '100%',
    height: '100%',
    padding: '1rem',
    borderRadius: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },

  emphasisText: {
    color: palette.error.dark,
  },
  deliveryText: {
    color: palette.error.dark,
  },
  changedDateText: {
    color: palette.error.dark,
  },
}));
